function loadScript(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}
$(document).ready(function () {
    $('#ccnumber').mask("0000000000000000000");
    $('#ccdate').mask("00/0000");
    $('#cccvc').mask("0000");

    if(!window.config?.stripe) return
    loadScript('https://js.stripe.com/v3/').then(() => {
        console.log('Stipe.js loaded.');
        var stripe = Stripe(window.config.stripe);
        var elements = stripe.elements();

        var style = {
            base: {
                color: '#32325d',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        var card = elements.create('card');
        if (document.getElementById('card-element')) {
            card.mount('#card-element');

            card.on('change', function (event) {
                var displayError = document.getElementById('card-errors');
                if (event.error) {
                    displayError.textContent = event.error.message;
                } else {
                    displayError.textContent = '';
                }
            });
        }

        $('#voucher').on('change keyup',function () {
            $('#voucher-error').html('')
        })

        $('#subscribe-form').submit(function (event) {
            $('#submit-button').prop('disabled', true);
            event.preventDefault();
            let voucher = $('#voucher').val()
            let type = $('#user-type').val()
            if (voucher) {
                axios.post('/broker/verify/token', {
                    voucher: voucher,
                    type: type
                }).then(function (resp) {
                    if (resp.data.status) {
                        $('#subscribe-form').get(0).submit();
                    } else{
                        $('#voucher-error').html('Invalid voucher code')
                        $('#submit-button').prop('disabled', false);
                    }
                })
            } else {
                stripe.createToken(card).then(function (result) {
                    if (result.error) {
                        $('#card-errors').html(result.error.message);
                        $('#submit-button').prop('disabled', false);
                    } else {
                        $('#token').val(result.token.id);
                        $('#subscribe-form').get(0).submit();
                    }
                });
            }
        });
    }).catch(error => {
        console.error('Failed to load Stripe.js', error);
    });
});

window.calculatePricing = function (certs, plan) {
    let costPerMonth;
    let costPerYear = 0;
    let savingPerYear = 0;
    let yearlyCost = 0;

    let slotSize = 50;
    let slots = Math.ceil(certs / slotSize);
    if (certs >= 501 && certs <= 750) {
        slots = 11;
    } else if (certs >= 751 && certs <= 1000) {
        slots = 12;
    }
    let originalCost = slots * 40;
    costPerMonth = originalCost;

    if (certs > 1000) {
        costPerYear = 'Contact Us';
        costPerMonth = 'Contact Us';
        savingPerYear = 'Contact Us';
        yearlyCost = 'Contact Us';
    } else if (plan === 'yearly') {
        costPerYear = (12 * originalCost) - originalCost;
        costPerMonth = costPerYear / 12;
        savingPerYear = (originalCost - costPerMonth) * 12;
        yearlyCost = costPerYear
    } else if (plan === '2years') {
        costPerYear = (24 * originalCost) - (3 * originalCost);
        costPerMonth = costPerYear / 24;
        savingPerYear = (originalCost - costPerMonth) * 12;
        yearlyCost = costPerYear / 2;
    } else if (plan === '3years') {
        costPerYear = (36 * originalCost) - (5 * originalCost);
        costPerMonth = costPerYear / 36;
        savingPerYear = (originalCost - costPerMonth) * 36;
        yearlyCost = costPerYear / 3;
    }

    costPerMonth = (costPerMonth).toFixed(2)
    costPerYear = (costPerYear).toFixed(2)
    savingPerYear = (savingPerYear).toFixed(2)
    yearlyCost = (yearlyCost).toFixed(2)

    return {
        costPerMonth, costPerYear, savingPerYear, yearlyCost
    }
}

window.calculatePropertyManagerPricing = function (certs, plan) {
    return calculatePricing(certs, plan)
}
